import { FormSectionHandler } from '../entity.handler';
import { DistributorResponse, DistributorUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, TagsField } from '../utils';
import { COMPANY_ICONS } from '../icons';

interface EditorValues {
    name?: string;
    website?: string;
    tags?: string[];
}

export class DistributorDetailsSectionHandler implements FormSectionHandler<DistributorResponse, EditorValues> {

    type = 'form';
    icon = COMPANY_ICONS.distributor;
    bulk = false;
    readonly = this.admin.user.owner.type === 'distributor';

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    private properties = ['name', 'website', 'tags'];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.DISTRIBUTOR.DETAILS.${key}`, values);
    }

    applyUpdate(entity: DistributorResponse, payload: DistributorUpdateRequest): Promise<DistributorResponse> {
        return this.admin.applyUpdate(api => api.accounts.updateDistributor(entity.id, payload), { _navigation: 'distributor' });
    }

    mapEntityToEditor(entity: DistributorResponse): Promise<EditorValues> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, entity, {}));
    }

    mapEditorToEntity(entity: any, values: EditorValues): Promise<any> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, values, entity));
    }

    getFields(entity: DistributorResponse): Promise<FormBuilderField[]> {
        return Promise.resolve([
            TextField('name', this.translate('FIELDS.NAME'), true, 1, 255),
            TextField('website', this.translate('FIELDS.WEBSITE'), true, 1, 255),
            TagsField('tags', this.translate('FIELDS.TAGS'), false),
        ]).then(fields => EntityUtils.prepareBulk(!entity, [], fields));
    }

}
